<script>
import { GET_ANSWER_STUDENT, MAKE_EXAM_SPEAKING } from "@/core/services/store/test/testInput.module";
import { TestModel } from "@/view/pages/test-input/models/test_model";
import CriteriaBlock from "@/view/pages/test-input/components/ComponentMarkTheExam/CriteriaBlock.vue";
import { WritingCriteria } from "@/core/option/newTestInputOption";
import { PLAGIARISM_RATE } from "@/core/option/testInputOption";
import CheckPlagiarism from "@/view/pages/test-input/components/ComponentMarkTheExam/CheckPlagiarism.vue";
import ModalConfirmedPlagiarism
  from "@/view/pages/test-input/components/ComponentMarkTheExam/ModalConfirmedPlagiarism.vue";
import router from "@/router";
import TabMenu from "../../../../../components/TabMenu.vue";
import { MARK_HIGH_BAND_WRITING } from "../../../../../core/services/store/test/testInput.module";
import { WritingCriteriaTaskOne, WritingCriteriaTaskTwo } from "../../../../../core/option/newTestInputOption";

export default {
  name: "MarkWritingHighBand",
  components: { TabMenu, ModalConfirmedPlagiarism, CheckPlagiarism, CriteriaBlock },
  props: {
    aiResult: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    aiResult: {
      deep: true,
      async handler(newVal) {
        const loading = this.$loading({
        lock: true,
        text: 'Đang tải dữ liệu...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
        await this.getAnswerStudent()
        if (newVal?.length > 0 && newVal) {
            const resultTask1 = newVal.find((result) => result.course_type === 'HighTask1')
          const resultTask2 = newVal.find((result) => result.course_type === 'HighTask2')
           this.markStatus.task1 = this.checkIsAIMark(resultTask1)
           this.markStatus.task2 = this.checkIsAIMark(resultTask2)
            this.writingCriteria?.[0]?.forEach((criteria) => {
              if(resultTask1){
                const criteriaResult = resultTask1?.score_breakdown?.find((c) => c.key === criteria.apiName)
                if(criteriaResult){
                  criteria.specificComment = criteriaResult.comment
                  criteria.isAIMark = this.checkIsAIMark(resultTask1)
                  criteria.point = criteria?.isAIMark?criteriaResult.point:null
                }
              }
            })
            this.writingCriteria?.[1]?.forEach((criteria) => {
              if(resultTask2){
                const criteriaResult = resultTask2?.score_breakdown?.find((c) => c.key === criteria.apiName)
                if(criteriaResult){
                  criteria.specificComment = criteriaResult.comment
                  criteria.isAIMark = this.checkIsAIMark(resultTask2)
                  criteria.point = criteria?.isAIMark?criteriaResult.point:null
                }
                
              }
            })
       }
         loading.close();
      },
      immediate: true
    }
  },
  data() {
    return {
      topic: '',
      dataTests: [],
      writingCriteria: [],
      PLAGIARISM_RATE: PLAGIARISM_RATE,
      plagiarismData: [],
      step: 0,
      tabs: ['Writing Task 1', 'Writing Task 2'],
      activeTab: 0,
      markStatus: {
        task1: false,
        task2: false
      }
    }
  },
  mounted() {
    
  },
  methods: {
    async getAnswerStudent() {
      
      const {id: test_input_schedule_id } = this.$route.params
      return this.$store.dispatch(GET_ANSWER_STUDENT, test_input_schedule_id).then((data) => {
        if (!data.error) {
          this.topic = data?.data?.topic
          this.dataTests = data?.data?.userAnswers.flat().map((element) => {
            return new TestModel(element?.description, element?.answers?.length > 0 ? element?.answers?.reduce((a, b) => a + b) : '', element?.isPassWriting)
          })
          this.writingCriteria = [structuredClone(WritingCriteriaTaskOne), structuredClone(WritingCriteriaTaskTwo)]
          this.plagiarismData = [{
            isPlagiarism: false,
            plagiarismRate: null,
            plagiarismComment: '',
          },
          {
            isPlagiarism: false,
            plagiarismRate: null,
            plagiarismComment: '',
          }]
        }
      }).finally(() => {
        return
      })
    },
    async confirm(isZeroPoint = false) {
      if (isZeroPoint) {
        this.writingCriteria[this.activeTab].forEach((criteria) => {
          criteria.point = 0
          criteria.specificComment = ''
        })
      }
      if (!this.isLastTab) {
        this.changeTab(null, this.activeTab + 1)
        return
      }
      let data = {
        type: "writing",
        version: 3,
        criterias: this.topic.map((task, index) => {
          return {
            task: index + 1,
            answer: this.writingCriteria[index].map((criteria) => {
              return {
                key: criteria.apiName,
                point: this.handlePoint(index, criteria.point),
                comment: this.handleCommentUnder20Word(index) ?? criteria.specificComment,
                comment_auto: criteria?.pointList?.find(point => point.band === criteria.point)?.eComment ?? '',
                v_comment_auto: criteria?.pointList?.find(point => point.band === criteria.point)?.vComment ?? ''
              }
            }),
            plagiarism: {
              type_of_plagiarism: this.plagiarismData[index].isPlagiarism ? this.plagiarismData[index].plagiarismRate : 0,
              description_of_plagiarism: this.plagiarismData[index].isPlagiarism ? this.plagiarismData[index].plagiarismComment : ''
            }
          }
        }),

      }
      let test_input_schedule_id = this.$route.params.id
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await this.$store.dispatch(MARK_HIGH_BAND_WRITING, { id: test_input_schedule_id, data: data }).then(() => {
        this.$message.success('Chấm Writing thành công');
        router.push({ name: 'task-details', params: { id: test_input_schedule_id } })
      }).finally(() => {
        loading.close();
      })

    },
    handleCommentUnder20Word(index) {
      if (this.dataTests.length === 0) return null
      return !this.dataTests[index]?.isPassWriting ? 'Bài làm dưới 20 từ, hệ thống tự động chấm 0 điểm.' : null
    },
    handlePoint(index, point = 0) {
      if (this.dataTests.length === 0) return point
      return !this.dataTests[index]?.isPassWriting ? 0 : point
    },
    markPlagiarism() {
      this.$bvModal.show("Modal-Confirmed-Plagiarism")
    },
    nextStep() {
      this.step = 1
    },
    changeTab(tab, index) {
      this.activeTab = index
      this.step = 0
    },
    backTab() {
      this.step = 0
      this.activeTab--
    },
    checkIsAIMark(result) {
      return result?.confidence?.raw_score >= 8 && result?.final_score > 4
    },
  },
  computed: {
    countWords() {
      const words = this.dataTests[this.activeTab]?.answerOfUser?.trim().split(/\s+/);
      if (words) {
        return words.length;
      }
      return 0
    },
    isFirstTab() {
      return this.activeTab === 0
    },
    isLastTab() {
      return this.activeTab === this.tabs.length - 1
    },
    currentDataStudent() {
      if (this.dataTests.length > 0) {
        return this.dataTests[this.activeTab]
      }
      return null
    },
  }

}
</script>

<template>
  <div class="row">
    <div class="col-12 d-flex">
      <TabMenu :tabs="tabs" class="mb-4" @changeTab="changeTab" :activeTab="activeTab" :disableTab="true">
        <template #tab="{ tab, index }">
          <span>{{ tab }}</span>
          <!-- Badge hiển thị ai là người chấm -->
          <span v-if="markStatus['task' + (index + 1)]" class="badge badge-success text-white ml-2" style="background-color: #28a745; font-size: 11px; padding: 4px 8px; border-radius: 12px; font-weight: 500;">
            ✨ AI chấm
          </span>
          <span v-else class="badge badge-secondary ml-2" style="font-size: 11px; padding: 4px 8px; border-radius: 12px; font-weight: 500;">
            👨‍🏫 Admin chấm  
          </span>
        </template>
      </TabMenu>
    </div>
    <div class="col-4 " style="height: 650px; overflow-y: scroll">
      <div v-if="!currentDataStudent?.isPassWriting" style="background-color: #F8F8F8" class="rounded px-4 py-4 col-12">
        <div
          style="display: flex;gap: 12px;padding: 14px 16px;background: #FFF4E5; border: 1px solid #FFD8A8;border-radius: 8px;color: #5F3A00;font-family: Arial, Helvetica, sans-serif;max-width: 600px;">
          <div
            style="width: 24px;height: 24px; min-width: 24px; border-radius: 50%; background: #FFA940; color: white; font-weight: bold; display: flex; align-items: center;   justify-content: center;   font-size: 16px;  ">
            !</div>
          <div>
            <div style="  font-size: 14px;font-weight: 600; margin-bottom: 4px;">
              Bài làm {{ tabs[activeTab] }} dưới 20 từ, hệ thống tự động chấm 0 điểm.
            </div>
            <div style="font-size: 13px;color: #8C6D1F; ">
              Vui lòng bấm nút để tiếp tục.
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button v-if="!isLastTab" type="button" class="btn btn-primary" @click="changeTab(null, activeTab + 1)">Tiếp
            theo
          </button>
          <button v-if="isLastTab" type="button" class="btn btn-secondary  mr-4" @click="backTab()">Quay lại</button>
          <button v-if="isLastTab" type="button" class="btn btn-primary" @click="confirm">Hoàn thành</button>
        </div>
      </div>
      <CheckPlagiarism v-else-if="step === 0" :PLAGIARISM_RATE="PLAGIARISM_RATE"
        :plagiarismData="plagiarismData[activeTab]" :haveBackButton="!isFirstTab" @markPlagiarism="markPlagiarism()"
        @nextStep="nextStep()" @backStep="backTab()"></CheckPlagiarism>
      <div v-else>
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent>
            <section>
              <div v-for="(criterion, index) in writingCriteria[activeTab]" :key="index" class="mb-6">
                <CriteriaBlock :criterion="criterion"></CriteriaBlock>
              </div>
            </section>
            <div class="d-flex justify-content-end mt-6">
              <button type="button" class="btn btn-secondary mr-4" @click="step = 0">Quay lại</button>
              <button v-if="!isLastTab" type="button" class="btn btn-primary"
                @click="handleSubmit(() => { changeTab(null, activeTab + 1) })">Tiếp theo
              </button>
              <button v-else type="button" class="btn btn-primary" @click="handleSubmit(confirm)">Hoàn thành</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <div class="col-8 ">
      <div class="pl-8">
        <div style="background-color: #F8F8F8;border-radius: 3px" class="p-4">
          <h4 style="font-weight: bold;font-size: 14px">Đề bài</h4>
          <div style="background-color: white;color: #4F4F4F" class="px-3 py-4 mt-4">
            <p style="font-weight: 400;" v-html="topic[activeTab]"></p>
          </div>
        </div>
        <div style="background-color: #F8F8F8;border-radius: 3px" class="p-4 mt-5">
          <h4 style="font-weight: bold;font-size: 14px">Bài làm của học viên</h4>
          <div style="background-color: white;color: #4F4F4F" class="px-3 py-4 mt-4 content_test">
            <p style="font-weight: 400;white-space:pre-line">{{ dataTests[activeTab]?.answerOfUser }}</p>
          </div>
          <p style="font-weight: normal;font-size: 13px" class="mb-0 mt-3">Số từ: <span>{{ countWords }}</span></p>
        </div>
      </div>
    </div>
    <ModalConfirmedPlagiarism @submit="confirm(true)" :title="`Xác nhận bài ${tabs[activeTab]} đạo văn từ 50% trở lên`">
      <p class="">Khi chọn tỉ lệ đạo văn từ 50% trở lên, hệ thống sẽ tự động chấm kĩ năng {{ tabs[activeTab] }} <span
          style="color: red">0 điểm</span>
        và {{ isLastTab ? 'nộp bài' : `chuyển sang ${tabs[activeTab + 1]}` }}</p>
    </ModalConfirmedPlagiarism>
  </div>
</template>

<style scoped></style>